import store from '@/store/store'

export default {
  methods: {
    showLoader () {
      store.commit('showLoader')
    },
    hideLoader () {
      store.commit('hideLoader')
    }
  }
}
